// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.workspace-public-site.public-theme-dark
  .workspace-public-docs
  .documentation-appearance-panel,
.workspace-public-site.public-theme-dark
  .workspace-public-docs
  .documentation-work-views-panel {
  border-color: #302a3b;
  background: #0d0b16;
  color: #dce2eb;
}

.workspace-public-site.public-theme-dark
  .workspace-public-docs
  .documentation-appearance-panel
  .section-header
  h2,
.workspace-public-site.public-theme-dark
  .workspace-public-docs
  .documentation-work-views-panel
  .section-header
  h2 {
  color: #f2f4f8;
}

.workspace-public-site.public-theme-dark
  .workspace-public-docs
  .documentation-appearance-panel
  .theme-mode-control,
.workspace-public-site.public-theme-dark
  .workspace-public-docs
  .documentation-appearance-panel
  .segmented-control,
.workspace-public-site.public-theme-dark
  .workspace-public-docs
  .documentation-work-views-panel
  .segmented-control,
.workspace-public-site.public-theme-dark
  .workspace-public-docs
  .documentation-work-views-panel
  .work-list,
.workspace-public-site.public-theme-dark
  .workspace-public-docs
  .documentation-work-views-panel
  .kanban-column {
  border-color: #302a3b;
  background: #11101b;
  color: #dce2eb;
}

.workspace-public-site.public-theme-dark
  .workspace-public-docs
  .documentation-appearance-panel
  .segmented-control
  button,
.workspace-public-site.public-theme-dark
  .workspace-public-docs
  .documentation-work-views-panel
  .segmented-control
  button {
  background: transparent;
  color: #aeb7c6;
  box-shadow: none;
}

.workspace-public-site.public-theme-dark
  .workspace-public-docs
  .documentation-appearance-panel
  .segmented-control
  button.active,
.workspace-public-site.public-theme-dark
  .workspace-public-docs
  .documentation-work-views-panel
  .segmented-control
  button.active {
  background: rgba(124, 58, 237, 0.2);
  color: #e9ddff;
}

.workspace-public-site.public-theme-dark
  .workspace-public-docs
  .documentation-work-views-panel
  .work-list-head {
  border-color: #302a3b;
  background: #090812;
  color: #929daf;
}

.workspace-public-site.public-theme-dark
  .workspace-public-docs
  .documentation-work-views-panel
  .work-list-row {
  border-color: #302a3b;
  background: #11101b;
  color: #dce2eb;
}

.workspace-public-site.public-theme-dark
  .workspace-public-docs
  .documentation-work-views-panel
  .work-list-row
  p,
.workspace-public-site.public-theme-dark
  .workspace-public-docs
  .documentation-work-views-panel
  .work-list-row
  strong {
  color: #e6eaf1;
}

.workspace-public-site.public-theme-dark
  .workspace-public-docs
  .documentation-work-views-panel
  .kanban-title
  span,
.workspace-public-site.public-theme-dark
  .workspace-public-docs
  .documentation-work-views-panel
  .kanban-card {
  border-color: #302a3b;
  background: #171420;
  color: #dce2eb;
}

.workspace-public-site.public-theme-dark
  .workspace-public-docs
  .documentation-work-views-panel
  .kanban-card
  p,
.workspace-public-site.public-theme-dark
  .workspace-public-docs
  .documentation-work-views-panel
  .kanban-card
  strong {
  color: #e6eaf1;
}

/* Public landing polish. */
.workspace-public-site .workspace-landing-proof {
  display: grid;
  grid-template-columns: minmax(280px, 0.85fr) minmax(360px, 1.15fr);
  align-items: center;
  gap: clamp(30px, 5vw, 64px);
  width: min(calc(100% - 48px), 1080px);
  margin: 0 auto;
  border: 1px solid;
  border-radius: 16px;
  padding: 22px 26px;
}

.workspace-public-site .workspace-landing-proof div {
  gap: 6px;
}

.workspace-public-site .workspace-landing-proof strong {
  font-size: 16px;
  line-height: 1.4;
}

.workspace-public-site .workspace-landing-proof p {
  max-width: none;
  font-size: 13px;
  line-height: 1.6;
  text-align: left;
}

.workspace-public-site .workspace-onboarding-choice {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.workspace-public-site .workspace-onboarding-choice-label {
  grid-column: 1 / -1;
  margin: 0 0 2px;
  color: #536075;
  font-size: 11px;
  font-weight: 500;
  line-height: 1.4;
}

.workspace-public-site .workspace-onboarding-choice > label {
  display: grid;
  grid-template-columns: 18px minmax(0, 1fr);
  align-items: center;
  gap: 12px;
  min-height: 68px;
  padding: 12px 14px;
}

.workspace-public-site .workspace-onboarding-choice input[type="radio"] {
  width: 17px;
  height: 17px;
  margin: 0;
}

.workspace-public-site .workspace-onboarding-choice label > span {
  display: grid;
  gap: 4px;
  min-width: 0;
}

.workspace-public-site .workspace-onboarding-choice strong {
  font-size: 13px;
  line-height: 1.3;
}

.workspace-public-site .workspace-onboarding-choice small {
  font-size: 11px;
  line-height: 1.4;
}

.workspace-public-site.public-theme-dark .workspace-onboarding-choice-label {
  color: #b5bdcb;
}

@media (max-width: 760px) {
  .workspace-public-site .workspace-landing-proof,
  .workspace-public-site .workspace-onboarding-choice {
    grid-template-columns: 1fr;
  }

  .workspace-public-site .workspace-landing-proof {
    width: min(calc(100% - 28px), 1080px);
    gap: 14px;
    padding: 20px;
  }

  .workspace-public-site .workspace-onboarding-choice-label {
    grid-column: 1;
  }
}

/* Static landing cards must paint with the initial page, without delayed blur layers. */
.workspace-public-site .workspace-onboarding-options > article,
.workspace-public-site .workspace-capability-grid > article {
  isolation: isolate;
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
}

.workspace-public-site .workspace-onboarding-options > article::before,
.workspace-public-site .workspace-capability-grid > article::before {
  display: none;
}

.workspace-public-site .workspace-landing-hero-copy {
  max-width: 610px;
}

.workspace-public-site .workspace-landing-hero h1 {
  max-width: 600px;
  margin: 14px 0 11px;
  font-size: clamp(38px, 3.65vw, 54px);
  line-height: 1.04;
}

.workspace-public-site .workspace-landing-hero-copy > p {
  max-width: 540px;
  font-size: 13px;
  line-height: 1.55;
}

.workspace-public-site .workspace-launch-offer {
  max-width: 540px;
  margin-top: 14px;
  padding: 10px 11px;
}

.workspace-public-site .workspace-landing-actions {
  margin-top: 16px;
}

@media (max-width: 760px) {
  .workspace-public-site .workspace-public-header {
    grid-template-columns: 36px minmax(0, 1fr);
    gap: 8px;
    min-height: 0;
    padding: 8px 10px;
  }

  .workspace-public-site .workspace-public-brand {
    width: 36px;
    min-width: 36px;
  }

  .workspace-public-site .workspace-public-brand div {
    display: none;
  }

  .workspace-public-site .workspace-public-header nav {
    position: static;
    grid-column: 1 / -1;
    grid-row: 2;
    width: 100%;
    box-shadow: none;
  }

  .workspace-public-site .workspace-public-header-actions {
    display: flex;
    width: 100%;
    min-width: 0;
    align-items: center;
    justify-content: flex-end;
    gap: 6px;
  }

  .workspace-public-site .workspace-public-header-sign-in {
    display: inline-flex;
    width: auto;
    min-height: 36px;
    max-width: calc(100% - 42px);
    flex: 0 0 auto;
    visibility: visible;
    gap: 5px;
    opacity: 1;
    padding: 0 10px;
    font-size: 11px;
    line-height: 1;
    white-space: nowrap;
  }

  .workspace-public-site .workspace-public-theme-toggle {
    display: inline-grid;
    width: 36px;
    min-width: 36px;
    min-height: 36px;
    flex: 0 0 36px;
    place-items: center;
    padding: 0;
  }

  .workspace-public-site .workspace-public-theme-toggle span {
    display: none;
  }

  .workspace-public-site .workspace-landing-hero {
    gap: 24px;
    padding-top: 34px;
  }

  .workspace-public-site .workspace-landing-hero h1 {
    font-size: clamp(34px, 10.5vw, 44px);
  }

  .workspace-public-site .workspace-product-floating-signal {
    display: none;
  }

  .workspace-public-site .workspace-product-stage {
    width: 100%;
    padding-bottom: 22px;
  }

  .workspace-public-site .workspace-public-docs-header,
  .workspace-public-site .workspace-public-docs-note,
  .workspace-public-site .workspace-public-docs .documentation-anchor-title,
  .workspace-public-site .workspace-public-docs .module-header-card,
  .workspace-public-site .workspace-public-docs .panel {
    padding: 14px;
  }

  .workspace-public-site .workspace-public-docs-header .secondary-action {
    width: 100%;
  }

  .workspace-public-site .workspace-public-docs .hero-panel {
    gap: 16px;
    padding: 14px;
  }
}

@media (max-width: 520px) {
  .workspace-public-site .workspace-public-header-actions {
    gap: 5px;
  }

  .workspace-public-site .workspace-public-header-sign-in {
    min-height: 36px;
    gap: 5px;
    padding: 0 10px;
    font-size: 11px;
  }

  .workspace-public-site .workspace-public-theme-toggle {
    width: 36px;
    min-height: 36px;
    padding: 0;
  }

  .workspace-public-site .workspace-landing-actions {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
  }

  .workspace-public-site .workspace-landing-actions > a {
    width: 100%;
    min-width: 0;
    min-height: 44px;
    gap: 4px;
    padding: 0 6px;
    font-size: 10.5px;
    white-space: nowrap;
  }

  .workspace-public-site .workspace-landing-actions > a svg {
    flex: 0 0 auto;
    font-size: 17px;
  }

  .workspace-public-site .workspace-launch-offer {
    grid-template-columns: 34px minmax(0, 1fr);
  }

  .workspace-public-site .workspace-launch-offer-icon {
    width: 34px;
    height: 34px;
  }

  .workspace-public-site .workspace-public-docs {
    padding-right: 10px;
    padding-left: 10px;
  }
}

@media (max-width: 360px) {
  .workspace-public-site .workspace-public-header {
    grid-template-columns: 34px minmax(0, 1fr);
    gap: 6px;
    padding: 0 8px;
  }

  .workspace-public-site .workspace-public-brand,
  .workspace-public-site .workspace-public-brand > span,
  .workspace-public-site .workspace-public-brand > img {
    width: 34px;
    min-width: 34px;
    height: 34px;
  }

  .workspace-public-site .workspace-public-header-sign-in {
    min-height: 34px;
    padding: 0 7px;
    font-size: 10px;
  }

  .workspace-public-site .workspace-public-theme-toggle {
    width: 34px;
    min-width: 34px;
    min-height: 34px;
    flex-basis: 34px;
  }
}

@media print {
  @page {
    size: A4;
    margin: 12mm;
  }

  html,
  body {
    background: #080b12 !important;
    color: #e8edf7 !important;
    print-color-adjust: exact;
  }

  .workspace-public-header,
  .workspace-public-sidebar,
  .workspace-sidebar,
  .workspace-topbar,
  .topbar-actions,
  .workspace-public-docs-note,
  .secondary-action,
  .workspace-help-trigger,
  .workspace-help-panel {
    display: none !important;
  }

  .workspace-public-site,
  .workspace-public-docs,
  .workspace-shell,
  .workspace-main,
  .workspace-content,
  .documentation-page {
    background: #080b12 !important;
    color: #e8edf7 !important;
  }

  .documentation-section,
  .workspace-public-docs .documentation-anchor-title,
  .workspace-public-docs .module-header-card,
  .workspace-public-docs .panel,
  .workspace-public-docs .info-card,
  .workspace-public-docs .step-item,
  .workspace-public-docs .auth-step,
  .workspace-public-docs .functional-metrics article,
  .workspace-public-docs .settings-grid article,
  .workspace-public-docs .permission-list article,
  .workspace-public-docs .documentation-leave-grid article,
  .workspace-public-docs .settings-security-grid article,
  .workspace-public-docs .documentation-request-list article,
  .workspace-public-docs .person-row {
    border-color: #2b3547 !important;
    background: #121925 !important;
    box-shadow: none !important;
    page-break-inside: avoid;
    break-inside: avoid;
  }

  .documentation-page h1,
  .documentation-page h2,
  .documentation-page h3,
  .documentation-page h4,
  .documentation-page strong,
  .documentation-page p,
  .documentation-page li,
  .documentation-page span {
    color: inherit !important;
  }

  .documentation-page h1,
  .documentation-page h2,
  .documentation-page h3,
  .documentation-page h4,
  .documentation-page strong {
    color: #f8fafc !important;
  }

  .documentation-page p,
  .documentation-page li,
  .documentation-page span {
    color: #c5cfdf !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/publicDocumentationTheme.css"],"names":[],"mappings":"AAAA;;;;;;EAME,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;;;;;;;EAUE,cAAc;AAChB;;AAEA;;;;;;;;;;;;;;;;;;;;EAoBE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;;;;;;;EAUE,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;;;;;;;;EAUE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;;;;EAIE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;EAIE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;;;;;;;EAUE,cAAc;AAChB;;AAEA;;;;;;;;;EASE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;;;;;;;EAUE,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,kEAAkE;EAClE,mBAAmB;EACnB,2BAA2B;EAC3B,qCAAqC;EACrC,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,qCAAqC;IACrC,SAAS;IACT,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,wFAAwF;AACxF;;EAEE,kBAAkB;EAClB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,0CAA0C;IAC1C,QAAQ;IACR,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,QAAQ;EACV;;EAEA;IACE,oBAAoB;IACpB,WAAW;IACX,gBAAgB;IAChB,4BAA4B;IAC5B,cAAc;IACd,mBAAmB;IACnB,QAAQ;IACR,UAAU;IACV,eAAe;IACf,eAAe;IACf,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;IACpB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,oBAAoB;EACtB;;EAEA;;;;;IAKE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAS;IACT,aAAa;EACf;AACF;;AAEA;EACE;IACE,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,QAAQ;IACR,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,gDAAgD;IAChD,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,QAAQ;IACR,cAAc;IACd,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,0CAA0C;IAC1C,QAAQ;IACR,cAAc;EAChB;;EAEA;;;IAGE,WAAW;IACX,eAAe;IACf,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,QAAQ;IACR,YAAY;EACd;;EAEA;;IAEE,8BAA8B;IAC9B,yBAAyB;IAEzB,yBAAyB;EAC3B;;EAEA;;;;;;;;;IASE,wBAAwB;EAC1B;;EAEA;;;;;;IAME,8BAA8B;IAC9B,yBAAyB;EAC3B;;EAEA;;;;;;;;;;;;;;IAcE,gCAAgC;IAChC,8BAA8B;IAC9B,2BAA2B;IAC3B,wBAAmB;IAAnB,mBAAmB;EACrB;;EAEA;;;;;;;;IAQE,yBAAyB;EAC3B;;EAEA;;;;;IAKE,yBAAyB;EAC3B;;EAEA;;;IAGE,yBAAyB;EAC3B;AACF","sourcesContent":[".workspace-public-site.public-theme-dark\n  .workspace-public-docs\n  .documentation-appearance-panel,\n.workspace-public-site.public-theme-dark\n  .workspace-public-docs\n  .documentation-work-views-panel {\n  border-color: #302a3b;\n  background: #0d0b16;\n  color: #dce2eb;\n}\n\n.workspace-public-site.public-theme-dark\n  .workspace-public-docs\n  .documentation-appearance-panel\n  .section-header\n  h2,\n.workspace-public-site.public-theme-dark\n  .workspace-public-docs\n  .documentation-work-views-panel\n  .section-header\n  h2 {\n  color: #f2f4f8;\n}\n\n.workspace-public-site.public-theme-dark\n  .workspace-public-docs\n  .documentation-appearance-panel\n  .theme-mode-control,\n.workspace-public-site.public-theme-dark\n  .workspace-public-docs\n  .documentation-appearance-panel\n  .segmented-control,\n.workspace-public-site.public-theme-dark\n  .workspace-public-docs\n  .documentation-work-views-panel\n  .segmented-control,\n.workspace-public-site.public-theme-dark\n  .workspace-public-docs\n  .documentation-work-views-panel\n  .work-list,\n.workspace-public-site.public-theme-dark\n  .workspace-public-docs\n  .documentation-work-views-panel\n  .kanban-column {\n  border-color: #302a3b;\n  background: #11101b;\n  color: #dce2eb;\n}\n\n.workspace-public-site.public-theme-dark\n  .workspace-public-docs\n  .documentation-appearance-panel\n  .segmented-control\n  button,\n.workspace-public-site.public-theme-dark\n  .workspace-public-docs\n  .documentation-work-views-panel\n  .segmented-control\n  button {\n  background: transparent;\n  color: #aeb7c6;\n  box-shadow: none;\n}\n\n.workspace-public-site.public-theme-dark\n  .workspace-public-docs\n  .documentation-appearance-panel\n  .segmented-control\n  button.active,\n.workspace-public-site.public-theme-dark\n  .workspace-public-docs\n  .documentation-work-views-panel\n  .segmented-control\n  button.active {\n  background: rgba(124, 58, 237, 0.2);\n  color: #e9ddff;\n}\n\n.workspace-public-site.public-theme-dark\n  .workspace-public-docs\n  .documentation-work-views-panel\n  .work-list-head {\n  border-color: #302a3b;\n  background: #090812;\n  color: #929daf;\n}\n\n.workspace-public-site.public-theme-dark\n  .workspace-public-docs\n  .documentation-work-views-panel\n  .work-list-row {\n  border-color: #302a3b;\n  background: #11101b;\n  color: #dce2eb;\n}\n\n.workspace-public-site.public-theme-dark\n  .workspace-public-docs\n  .documentation-work-views-panel\n  .work-list-row\n  p,\n.workspace-public-site.public-theme-dark\n  .workspace-public-docs\n  .documentation-work-views-panel\n  .work-list-row\n  strong {\n  color: #e6eaf1;\n}\n\n.workspace-public-site.public-theme-dark\n  .workspace-public-docs\n  .documentation-work-views-panel\n  .kanban-title\n  span,\n.workspace-public-site.public-theme-dark\n  .workspace-public-docs\n  .documentation-work-views-panel\n  .kanban-card {\n  border-color: #302a3b;\n  background: #171420;\n  color: #dce2eb;\n}\n\n.workspace-public-site.public-theme-dark\n  .workspace-public-docs\n  .documentation-work-views-panel\n  .kanban-card\n  p,\n.workspace-public-site.public-theme-dark\n  .workspace-public-docs\n  .documentation-work-views-panel\n  .kanban-card\n  strong {\n  color: #e6eaf1;\n}\n\n/* Public landing polish. */\n.workspace-public-site .workspace-landing-proof {\n  display: grid;\n  grid-template-columns: minmax(280px, 0.85fr) minmax(360px, 1.15fr);\n  align-items: center;\n  gap: clamp(30px, 5vw, 64px);\n  width: min(calc(100% - 48px), 1080px);\n  margin: 0 auto;\n  border: 1px solid;\n  border-radius: 16px;\n  padding: 22px 26px;\n}\n\n.workspace-public-site .workspace-landing-proof div {\n  gap: 6px;\n}\n\n.workspace-public-site .workspace-landing-proof strong {\n  font-size: 16px;\n  line-height: 1.4;\n}\n\n.workspace-public-site .workspace-landing-proof p {\n  max-width: none;\n  font-size: 13px;\n  line-height: 1.6;\n  text-align: left;\n}\n\n.workspace-public-site .workspace-onboarding-choice {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px;\n}\n\n.workspace-public-site .workspace-onboarding-choice-label {\n  grid-column: 1 / -1;\n  margin: 0 0 2px;\n  color: #536075;\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 1.4;\n}\n\n.workspace-public-site .workspace-onboarding-choice > label {\n  display: grid;\n  grid-template-columns: 18px minmax(0, 1fr);\n  align-items: center;\n  gap: 12px;\n  min-height: 68px;\n  padding: 12px 14px;\n}\n\n.workspace-public-site .workspace-onboarding-choice input[type=\"radio\"] {\n  width: 17px;\n  height: 17px;\n  margin: 0;\n}\n\n.workspace-public-site .workspace-onboarding-choice label > span {\n  display: grid;\n  gap: 4px;\n  min-width: 0;\n}\n\n.workspace-public-site .workspace-onboarding-choice strong {\n  font-size: 13px;\n  line-height: 1.3;\n}\n\n.workspace-public-site .workspace-onboarding-choice small {\n  font-size: 11px;\n  line-height: 1.4;\n}\n\n.workspace-public-site.public-theme-dark .workspace-onboarding-choice-label {\n  color: #b5bdcb;\n}\n\n@media (max-width: 760px) {\n  .workspace-public-site .workspace-landing-proof,\n  .workspace-public-site .workspace-onboarding-choice {\n    grid-template-columns: 1fr;\n  }\n\n  .workspace-public-site .workspace-landing-proof {\n    width: min(calc(100% - 28px), 1080px);\n    gap: 14px;\n    padding: 20px;\n  }\n\n  .workspace-public-site .workspace-onboarding-choice-label {\n    grid-column: 1;\n  }\n}\n\n/* Static landing cards must paint with the initial page, without delayed blur layers. */\n.workspace-public-site .workspace-onboarding-options > article,\n.workspace-public-site .workspace-capability-grid > article {\n  isolation: isolate;\n  backdrop-filter: none;\n  -webkit-backdrop-filter: none;\n}\n\n.workspace-public-site .workspace-onboarding-options > article::before,\n.workspace-public-site .workspace-capability-grid > article::before {\n  display: none;\n}\n\n.workspace-public-site .workspace-landing-hero-copy {\n  max-width: 610px;\n}\n\n.workspace-public-site .workspace-landing-hero h1 {\n  max-width: 600px;\n  margin: 14px 0 11px;\n  font-size: clamp(38px, 3.65vw, 54px);\n  line-height: 1.04;\n}\n\n.workspace-public-site .workspace-landing-hero-copy > p {\n  max-width: 540px;\n  font-size: 13px;\n  line-height: 1.55;\n}\n\n.workspace-public-site .workspace-launch-offer {\n  max-width: 540px;\n  margin-top: 14px;\n  padding: 10px 11px;\n}\n\n.workspace-public-site .workspace-landing-actions {\n  margin-top: 16px;\n}\n\n@media (max-width: 760px) {\n  .workspace-public-site .workspace-public-header {\n    grid-template-columns: 36px minmax(0, 1fr);\n    gap: 8px;\n    min-height: 0;\n    padding: 8px 10px;\n  }\n\n  .workspace-public-site .workspace-public-brand {\n    width: 36px;\n    min-width: 36px;\n  }\n\n  .workspace-public-site .workspace-public-brand div {\n    display: none;\n  }\n\n  .workspace-public-site .workspace-public-header nav {\n    position: static;\n    grid-column: 1 / -1;\n    grid-row: 2;\n    width: 100%;\n    box-shadow: none;\n  }\n\n  .workspace-public-site .workspace-public-header-actions {\n    display: flex;\n    width: 100%;\n    min-width: 0;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 6px;\n  }\n\n  .workspace-public-site .workspace-public-header-sign-in {\n    display: inline-flex;\n    width: auto;\n    min-height: 36px;\n    max-width: calc(100% - 42px);\n    flex: 0 0 auto;\n    visibility: visible;\n    gap: 5px;\n    opacity: 1;\n    padding: 0 10px;\n    font-size: 11px;\n    line-height: 1;\n    white-space: nowrap;\n  }\n\n  .workspace-public-site .workspace-public-theme-toggle {\n    display: inline-grid;\n    width: 36px;\n    min-width: 36px;\n    min-height: 36px;\n    flex: 0 0 36px;\n    place-items: center;\n    padding: 0;\n  }\n\n  .workspace-public-site .workspace-public-theme-toggle span {\n    display: none;\n  }\n\n  .workspace-public-site .workspace-landing-hero {\n    gap: 24px;\n    padding-top: 34px;\n  }\n\n  .workspace-public-site .workspace-landing-hero h1 {\n    font-size: clamp(34px, 10.5vw, 44px);\n  }\n\n  .workspace-public-site .workspace-product-floating-signal {\n    display: none;\n  }\n\n  .workspace-public-site .workspace-product-stage {\n    width: 100%;\n    padding-bottom: 22px;\n  }\n\n  .workspace-public-site .workspace-public-docs-header,\n  .workspace-public-site .workspace-public-docs-note,\n  .workspace-public-site .workspace-public-docs .documentation-anchor-title,\n  .workspace-public-site .workspace-public-docs .module-header-card,\n  .workspace-public-site .workspace-public-docs .panel {\n    padding: 14px;\n  }\n\n  .workspace-public-site .workspace-public-docs-header .secondary-action {\n    width: 100%;\n  }\n\n  .workspace-public-site .workspace-public-docs .hero-panel {\n    gap: 16px;\n    padding: 14px;\n  }\n}\n\n@media (max-width: 520px) {\n  .workspace-public-site .workspace-public-header-actions {\n    gap: 5px;\n  }\n\n  .workspace-public-site .workspace-public-header-sign-in {\n    min-height: 36px;\n    gap: 5px;\n    padding: 0 10px;\n    font-size: 11px;\n  }\n\n  .workspace-public-site .workspace-public-theme-toggle {\n    width: 36px;\n    min-height: 36px;\n    padding: 0;\n  }\n\n  .workspace-public-site .workspace-landing-actions {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 8px;\n  }\n\n  .workspace-public-site .workspace-landing-actions > a {\n    width: 100%;\n    min-width: 0;\n    min-height: 44px;\n    gap: 4px;\n    padding: 0 6px;\n    font-size: 10.5px;\n    white-space: nowrap;\n  }\n\n  .workspace-public-site .workspace-landing-actions > a svg {\n    flex: 0 0 auto;\n    font-size: 17px;\n  }\n\n  .workspace-public-site .workspace-launch-offer {\n    grid-template-columns: 34px minmax(0, 1fr);\n  }\n\n  .workspace-public-site .workspace-launch-offer-icon {\n    width: 34px;\n    height: 34px;\n  }\n\n  .workspace-public-site .workspace-public-docs {\n    padding-right: 10px;\n    padding-left: 10px;\n  }\n}\n\n@media (max-width: 360px) {\n  .workspace-public-site .workspace-public-header {\n    grid-template-columns: 34px minmax(0, 1fr);\n    gap: 6px;\n    padding: 0 8px;\n  }\n\n  .workspace-public-site .workspace-public-brand,\n  .workspace-public-site .workspace-public-brand > span,\n  .workspace-public-site .workspace-public-brand > img {\n    width: 34px;\n    min-width: 34px;\n    height: 34px;\n  }\n\n  .workspace-public-site .workspace-public-header-sign-in {\n    min-height: 34px;\n    padding: 0 7px;\n    font-size: 10px;\n  }\n\n  .workspace-public-site .workspace-public-theme-toggle {\n    width: 34px;\n    min-width: 34px;\n    min-height: 34px;\n    flex-basis: 34px;\n  }\n}\n\n@media print {\n  @page {\n    size: A4;\n    margin: 12mm;\n  }\n\n  html,\n  body {\n    background: #080b12 !important;\n    color: #e8edf7 !important;\n    -webkit-print-color-adjust: exact;\n    print-color-adjust: exact;\n  }\n\n  .workspace-public-header,\n  .workspace-public-sidebar,\n  .workspace-sidebar,\n  .workspace-topbar,\n  .topbar-actions,\n  .workspace-public-docs-note,\n  .secondary-action,\n  .workspace-help-trigger,\n  .workspace-help-panel {\n    display: none !important;\n  }\n\n  .workspace-public-site,\n  .workspace-public-docs,\n  .workspace-shell,\n  .workspace-main,\n  .workspace-content,\n  .documentation-page {\n    background: #080b12 !important;\n    color: #e8edf7 !important;\n  }\n\n  .documentation-section,\n  .workspace-public-docs .documentation-anchor-title,\n  .workspace-public-docs .module-header-card,\n  .workspace-public-docs .panel,\n  .workspace-public-docs .info-card,\n  .workspace-public-docs .step-item,\n  .workspace-public-docs .auth-step,\n  .workspace-public-docs .functional-metrics article,\n  .workspace-public-docs .settings-grid article,\n  .workspace-public-docs .permission-list article,\n  .workspace-public-docs .documentation-leave-grid article,\n  .workspace-public-docs .settings-security-grid article,\n  .workspace-public-docs .documentation-request-list article,\n  .workspace-public-docs .person-row {\n    border-color: #2b3547 !important;\n    background: #121925 !important;\n    box-shadow: none !important;\n    break-inside: avoid;\n  }\n\n  .documentation-page h1,\n  .documentation-page h2,\n  .documentation-page h3,\n  .documentation-page h4,\n  .documentation-page strong,\n  .documentation-page p,\n  .documentation-page li,\n  .documentation-page span {\n    color: inherit !important;\n  }\n\n  .documentation-page h1,\n  .documentation-page h2,\n  .documentation-page h3,\n  .documentation-page h4,\n  .documentation-page strong {\n    color: #f8fafc !important;\n  }\n\n  .documentation-page p,\n  .documentation-page li,\n  .documentation-page span {\n    color: #c5cfdf !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
